import Helmet from "react-helmet";
import { useLocation } from 'react-router-dom';

const MetaDescripProfilePages = ({ fetchData, subPage }) => {

  const helmetConfig = {
    gallery: {
      getUserName: (data) => data.user_name,
      subPages: {
        artworks: {
          getTitle: (name) => `${name}’s Artworks on Suarte`,
          getDescription: (name) =>
            `Explore the unique collection of ${name}. Immerse yourself in a world where each artwork tells its own story, waiting to be discovered.`,
        },
        artists: {
          getTitle: (name) => `${name}’s Artists on Suarte`,
          getDescription: (name) =>
            `Meet the creative minds behind ${name}'s exceptional art. Get inspired by their profiles, and uncover unique art.`,
        },
        artlists: {
          getTitle: (name) => `View and play ${name}’s curated artlists `,
          getDescription: (name) =>
            `Experience ${name}'s selected artlists. Press play and connect with curated art that aligns with your aesthetics and emotions.`,
        },
        board: {
          getTitle: (name) => `${name}’s board | Discover posts`,
          getDescription: (name) =>
            `Stay updated with ${name}'s latest news, events, and exclusive stories. Discover posts that bring you closer to the art market and our art community.`,
        },
      }
    },

    artist: {
      getUserName: (data) => data.user_name,
      subPages: {
        artworks: {
          getTitle: (name) => `${name}'s artworks on Suarte`,
          getDescription: (name) =>
            `Wander through the essence of ${name}'s art. Discover pieces that blend unique expression with artistic dialogue.`,
        },
        community: {
          getTitle: (name) => `${name}'s community interactions`,
          getDescription: (name) =>
            `Dive into ${name} unique perspectives through thoughts and ratings on Suarte.`,
        },
        artlists: {
          getTitle: (name) => `Play ${name}’s curated artlists `,
          getDescription: (name) =>
            `Journey through collections personally curated by ${name}. Press play and connect with curated art that aligns with your aesthetics and emotions.`,
        },
        collection: {
          getTitle: (name) => `${name}’s collection on Suarte`,
          getDescription: (name) =>
            `View ${name} purchased artworks on Suarte. Explore artwork(s) that serve as a reflection of the collector's journey and tastes.`,
        },

      }
    },

    collector: {
      getUserName: (data) => data.user_username,
      subPages: {
        collection: {
          getTitle: (name) => `${name}’s collection on Suarte`,
          getDescription: (name) =>
            `${name} is a verified art traveler. Explore artwork(s) that serve as a reflection of the collector's journey and tastes.`,
        },
        community: {
          getTitle: (name) => `${name}'s community interactions`,
          getDescription: (name) =>
            `Dive into ${name}’s unique perspectives through thoughts and ratings on Suarte.`,
        },
        artlists: {
          getTitle: (name) => `Play ${name}’s curated artlists `,
          getDescription: (name) =>
            `Journey through collections personally curated by ${name}. Press play and connect with curated art that aligns with your aesthetics and emotions.`,
        },
      }

    }
  };

  const { pathname } = useLocation();

  const isNotUserPage=()=>{
    return pathname.split("/").length>=4; 
  };

  const currentHelment = helmetConfig[fetchData.user_type];

  const metaTitle = currentHelment.subPages[subPage]?.getTitle(fetchData.user_name || fetchData.user_username);
  const metaDesc = currentHelment.subPages[subPage]?.getDescription(fetchData.user_name || fetchData.user_username);

  return (
    <>
      {isNotUserPage() && (
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDesc} />
        </Helmet>
      )}
    </>
   
  );
};

export default MetaDescripProfilePages;